"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartPane = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const fa_1 = require("react-icons/fa");
const useWindowSize_1 = __importDefault(require("../../hooks/useWindowSize"));
const Button_1 = require("../Button");
function CartPane({ children, className, openByDefault = false, mobileBreakpoint = 960, smallMobileBreakpoint = 480, subtotal, itemCount, ctaText, ctaHref = '/en/checkout/shopping-cart', ctaAction, ctaProps, mobileCtaProps, ctaClassName, mobileCtaClassName, onToggleCollapse, desktopAction, }) {
    const [cartOpen, setCartOpen] = (0, react_1.useState)(openByDefault || false);
    const { width } = (0, useWindowSize_1.default)();
    const isMobile = width && width < mobileBreakpoint;
    const isSmallMobile = width && width < smallMobileBreakpoint;
    const toggleCart = () => {
        setCartOpen(!cartOpen);
        if (onToggleCollapse)
            onToggleCollapse();
    };
    (0, react_1.useEffect)(() => {
        if (cartOpen && width && width < 1440) {
            document.body.classList.add('overflow-hidden');
        }
        else {
            document.body.classList.remove('overflow-hidden');
        }
        if (cartOpen && width && width >= 1440) {
            document.body.classList.add('cart-pane-open');
        }
        else {
            document.body.classList.remove('cart-pane-open');
        }
    }, [cartOpen, width]);
    (0, react_1.useEffect)(() => {
        if (openByDefault !== cartOpen) {
            setCartOpen(openByDefault);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openByDefault]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("aside", { className: (0, classnames_1.default)('fixed bottom-0 z-50 right-0 bg-gray-f5 print:hidden', {
                'left-0 w-full transform lg:w-[160px]': isMobile,
            }, {
                'top-0 h-screen transition-width': !isMobile,
            }, {
                'w-[160px]': !isMobile && !cartOpen,
            }, {
                'w-[375px]': !isMobile && cartOpen,
            }, className) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('relative h-full', {
                    'p-[15px] pb-0': isMobile,
                }, {
                    'px-4 pt-4 flex flex-col': !isMobile,
                }, className) },
                !isMobile && (react_1.default.createElement("div", { className: "flex flex-col p-4 bg-white mb-4" },
                    react_1.default.createElement("div", { className: "flex w-full items-center mb-2" },
                        react_1.default.createElement("button", { className: "bg-blue hover:bg-blue-hover text-white rounded-full shadow-md text-sm h-[29px] w-[29px] min-w-[29px] flex justify-center items-center z-10", onClick: toggleCart },
                            react_1.default.createElement(fa_1.FaChevronLeft, { className: (0, classnames_1.default)('transform', {
                                    'rotate-0': !cartOpen,
                                    'rotate-180': cartOpen,
                                }) }),
                            react_1.default.createElement("span", { className: "sr-only" }, cartOpen ? 'minimize cart view' : 'expand cart view')),
                        react_1.default.createElement("section", { className: "flex-grow text-right" },
                            react_1.default.createElement("p", { className: (0, classnames_1.default)('font-medium leading-5', {
                                    'text-sm': !cartOpen,
                                    'text-lg': cartOpen,
                                }) },
                                react_1.default.createElement("span", { className: (0, classnames_1.default)({
                                        'text-xs': !cartOpen,
                                        'text-lg': cartOpen,
                                    }) },
                                    "Subtotal:",
                                    ' '),
                                react_1.default.createElement("span", null, subtotal)),
                            cartOpen && (react_1.default.createElement("p", { className: "text-xs mt-[-5px]" },
                                react_1.default.createElement("span", null, "Items: "),
                                react_1.default.createElement("span", null, itemCount))))),
                    react_1.default.createElement("a", Object.assign({ className: (0, classnames_1.default)(Button_1.baseButtonStyles, 'w-full', Button_1.variants['yellow']({ disabled: false }), Button_1.sizes['sm'], ctaClassName), href: ctaHref, onClick: (e) => {
                            if (ctaAction) {
                                e.preventDefault();
                                ctaAction();
                            }
                        } }, ctaProps), ctaText))),
                isMobile && (react_1.default.createElement("div", { className: "flex" },
                    react_1.default.createElement("div", { className: "flex flex-grow items-center bg-white rounded py-1 px-3" },
                        react_1.default.createElement("button", { className: "bg-blue hover:bg-blue-hover text-white rounded-full shadow-md text-sm h-[23px] w-[23px] flex justify-center items-center z-10", onClick: toggleCart },
                            react_1.default.createElement(fa_1.FaChevronUp, { className: (0, classnames_1.default)('transform', {
                                    'rotate-0': !cartOpen,
                                    'rotate-180': cartOpen,
                                }) }),
                            react_1.default.createElement("span", { className: "sr-only" }, cartOpen ? 'minimize cart view' : 'expand cart view')),
                        react_1.default.createElement("p", { className: "flex-grow font-medium my-0 mx-2 text-gray" },
                            !isSmallMobile && react_1.default.createElement("span", null, "Subtotal: "),
                            react_1.default.createElement("span", null, subtotal)),
                        react_1.default.createElement("p", { className: "bg-gray rounded-2xl text-white block text-sm font-medium leading-4 py-1 px-2" },
                            !isSmallMobile && react_1.default.createElement("span", null, "Items: "),
                            react_1.default.createElement("span", null, itemCount))),
                    react_1.default.createElement("a", Object.assign({ className: (0, classnames_1.default)(Button_1.baseButtonStyles, 'ml-4', Button_1.variants['yellow']({ disabled: false }), Button_1.sizes['sm'], mobileCtaClassName), href: ctaHref, onClick: (e) => {
                            if (ctaAction) {
                                e.preventDefault();
                                ctaAction();
                            }
                        } }, mobileCtaProps), ctaText))),
                react_1.default.createElement("div", { className: (0, classnames_1.default)('overflow-y-auto -mx-4 overflow-x-hidden grow', {
                        'mt-4 overflow-y-auto transition-height duration-100': isMobile,
                    }, {
                        'max-h-0': !cartOpen && isMobile,
                        'max-h-[400px]': cartOpen && isMobile,
                    }) },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('relative px-4 pb-4', {
                            'bg-white p-2 mb-[15px]': isMobile,
                        }) },
                        !cartOpen && !isMobile && (react_1.default.createElement("button", { onClick: toggleCart, className: "block absolute top-0 bottom-0 left-0 right-0 w-full" },
                            react_1.default.createElement("span", { className: "sr-only" }, cartOpen ? 'minimize cart view' : 'expand cart view'))),
                        children))))));
}
exports.CartPane = CartPane;
